export default __webpack_public_path__ + "static/media/include_7_female@2x.cf8fe46f.jpg";